'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObservable = require('is-observable');

var _isObservable2 = _interopRequireDefault(_isObservable);

var _StyleRule = require('../rules/StyleRule');

var _StyleRule2 = _interopRequireDefault(_StyleRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var style = rule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      value.subscribe({
        next: function next(nextValue) {
          // $FlowFixMe
          rule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/jss/lib/plugins/observables.js
// module id = 737
// module chunks = 0